export default [{
  path: '/review',
  component: () => import('@/views/review'),
  children: [{
    path: ':type',
    component: () => import('@/views/review/main')
  }]
}]
